<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let store = offshoreOperationalStore;
  @let vm = offshoreReportStore.vm();
  <h1 class="mb-4 self-center text-xl">Report Details</h1>
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'reportNumber')"
    id="reportNumber"
    name="reportNumber"
    label="Report Number"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportNumber')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportNumber')"
    [value]="store.reportDetails?.()?.reportNumber?.value"
    [ngModel]="store.reportDetails?.()?.reportNumber?.value"
  />

  <nsp-calendar-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'reportCreation')"
    [name]="'reportCreation'"
    [id]="'reportCreation'"
    label="Report Creation"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportCreation')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportCreation')"
    [value]="store.reportDetails?.()?.reportCreation?.value"
    [ngModel]="store.reportDetails?.()?.reportCreation?.value"
  />

  <nsp-calendar-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'reportFrom')"
    [name]="'reportFrom'"
    [id]="'reportFrom'"
    label="Report From"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportFrom')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportFrom')"
    [value]="store.reportDetails?.()?.reportFrom?.value"
    [ngModel]="store.reportDetails?.()?.reportFrom?.value"
  />
  <nsp-calendar-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'reportTo')"
    [name]="'reportTo'"
    [id]="'reportTo'"
    label="Report To"
    [labelWidthPercentage]="33"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportTo')"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportTo')"
    [value]="store.reportDetails?.()?.reportTo?.value"
    [ngModel]="store.reportDetails?.()?.reportTo?.value"
    [min]="store.reportDetails?.()?.reportFrom?.value"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'reportPeriod')"
    [name]="'reportPeriod'"
    [id]="'reportPeriod'"
    label="Report Period"
    [unit]="'Hours'"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportPeriod')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportPeriod')"
    [ngModel]="store.vm().reportPeriod('reportDetails')"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'timeSailed')"
    [name]="'timeSailed'"
    [id]="'timeSailed'"
    label="Time Sailed"
    [unit]="'Hours'"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'timeSailed')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'timeSailed')"
    [value]="store.reportDetails?.()?.timeSailed?.value"
    [ngModel]="store.reportDetails?.()?.timeSailed?.value"
  />

  <nsp-select-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'timezone')"
    [name]="'timezone'"
    [id]="'timezone'"
    label="Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'timezone')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'timezone')"
    [value]="store.reportDetails?.()?.timezone?.value"
    [ngModel]="store.reportDetails?.()?.timezone?.value"
  />
  <nsp-select-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'previousTimezone')"
    [name]="'previousTimezone'"
    [id]="'previousTimezone'"
    label="Previous Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'previousTimezone')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'previousTimezone')"
    [value]="store.reportDetails?.()?.previousTimezone?.value"
    [ngModel]="store.reportDetails?.()?.previousTimezone?.value"
  />

  <nsp-calendar-input
    *nspVisible="
      vm.isFieldVisible(tabId, sectionId, 'reportSubmitted') &&
      !!store.reportDetails?.()?.reportFrom?.value
    "
    [name]="'reportSubmitted'"
    [id]="'reportSubmitted'"
    label="Report Submitted"
    [labelWidthPercentage]="33"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'reportSubmitted')"
    [required]="vm.isFieldRequired(tabId, sectionId, 'reportSubmitted')"
    [value]="store.reportDetails?.()?.reportSubmitted?.value"
    [ngModel]="store.reportDetails?.()?.reportSubmitted?.value"
    [min]="store.reportDetails?.()?.reportFrom?.value"
  />
</form>
